export default __webpack_public_path__ + "static/media/DustCollectorImg.b4b0f591.jpg";